export default {
	chargeAndDischargeStatistics: '充放电量统计',
	faultStatistics: '故障统计',
	projectStatistics: '项目统计',
	ownerStatistics: '业主统计',
	revenueForecast: '收益预测',
	revenueStatistics: '收益统计',
	online:'在线',
	offline:'离线',
	fault:'故障',
	electricityTitle:'> > > 充放电量统计(kwh)',
	faultStatisticstop5:'> > > 故障统计(Top5)',
	projectStatisticsTitle: '> > >项目统计',
	ownersData:'> > > 业主统计',
	revenueForecastTitle:'> > > 收益预测',
	revenueStatisticsTitle:'> > > 收益统计',
	totalRevenue:'总收益额:',
	footerList:[
	{
		img:'../../../static/image/icon1.png',
		imgactive:'../../../static/image/iconactive1.png',
		title:'充放电量统计',
		activestatus:false
	},{
		img:'../../../static/image/icon2.png',
		imgactive:'../../../static/image/iconactive2.png',
		title:'故障统计',
		activestatus:false
	},{
		img:'../../../static/image/icon3.png',
		imgactive:'../../../static/image/iconactive3.png',
		title:'项目统计',
		activestatus:false
	},{
		img:'../../../static/image/icon4.png',
		imgactive:'../../../static/image/iconactive4.png',
		title:'业主统计',
		activestatus:false
	},{
		img:'../../../static/image/icon5.png',
		imgactive:'../../../static/image/iconactive5.png',
		title:'收益预测',
		activestatus:false
	},{
		img:'../../../static/image/icon6.png',
		imgactive:'../../../static/image/iconactive6.png',
		title:'收益统计',
		activestatus:false
	},{
		img:'../../../static/image/yw.png',
		imgactive:'../../../static/image/yw-active.png',
		title:'智能运维',
		activestatus:false
	}],
	rightList:[
	{
		img:'../../../static/image/offline.png',
		title:'离线'
	},
	{
		img:'../../../static/image/online.png',
		title:'在线'
	},{
		img:'../../../static/image/abnormal.png',
		title:'异常'
	},{
		img:'../../../static/image/fault.png',
		title:'故障'
	}
	],
	dailyCharge:'日充电量',
	dailyDischarge:'日放电量',
	totalChargeCapacity:'总充电量',
	totalDischargeCapacity:'总放电量',
	numberOfOwners:'业主数量',
	totalProjectCapacity:'项目总容量',
	year:'年',
	month:'月',
	week:'周',
	bmsTitle:'III BMS',
	pcsTitle: 'PCS',
	projectType:'项目类型',
	ownersType:'业主类型',
	nodata:'暂无数据',
	voltage:'电压',
	popoverList:[{
		name:'项目档案管理',
		path:'projectFiles'
	},{
		name:'备品备件管理',
		path:'sparePartsManagement'
	},{
		name:'工单管理',
		path:'workOrder'
	},{
		name:'运维报告分析',
		path:'opsReportAnalysis'
	},{
		name:'用户行为分析',
		path:'userBehaviorAnalysis'
	},{
		name: '项目配置管理',
		path: 'configurationManagement'
	},{
		name: '下载数据',
		path: 'downloadData'
	}]
}



// WEBPACK FOOTER //
// ./src/config/i18n/zh-cn/maps.js